import { ListItem, ListItemType } from './interfaces'

/**
 * Description view for the list page.
 */
export class ListDescriptionView implements ListItem {
  id: string
  title: string
  url_slug: string
  created: string
  doc_type: ListItemType
  blurb?: string
  cover_image?: string

  showFullText: boolean

  docsNumber: string

  constructor(docGroup: ListItem, docsNumber: string) {
    this.id = docGroup.id
    this.title = docGroup.title
    this.url_slug = docGroup.url_slug
    this.created = docGroup.created
    this.doc_type = docGroup.doc_type
    this.blurb = docGroup.blurb
    this.cover_image = docGroup.cover_image

    this.showFullText = !this.hasLongText
    this.docsNumber = `${docsNumber} books`
  }

  get fullText(): string {
    return this.blurb as string
  }

  get imageUrl(): string {
    return this.cover_image as string
  }

  get hasLongText(): boolean {
    return this.fullText.length > 500
  }

  get shortText(): string {
    return this.fullText.substring(0, 500) + '...'
  }

  get displayedText(): string {
    return this.showFullText ? this.fullText : this.shortText
  }

  toggleShowFullText(): void {
    this.showFullText = !this.showFullText
  }
}
